module.exports = __webpack_public_path__ + "img/campic.png.59677d63.png";